export function generateSystemId() {
    const id = new Date().getTime();
    return `${id}`;
}
